{
  "shared": {
    "chart": {
      "showTable": "العرض كجدول",
      "hideTable": "إخفاء الجدول",
      "asOf": "حتى {{time}}",
      "unavailable": "هذه الأرقام غير متاحة لصلاحياتك.",
      "noRows": "لا توجد أرقام لعرضها.",
      "toDate": "حتى تاريخه",
      "monthColumn": "الشهر",
      "tooFewMonths": "الأشهر التي فيها نشاط أقل من أن تُرسم اتجاهًا: {{active}} من {{total}}. كل شهر فيه نشاط:",
      "latest": "الأحدث",
      "highest": "الأعلى",
      "inspectMonths": "عرض تفاصيل الأشهر",
      "inspect": "عرض تفاصيل {{label}}",
      "pointValues": "{{month}}: {{values}}",
      "meter": {
        "used": "مستخدم {{percent}}",
        "committed": "الملتزم به",
        "reserved": "المحجوز",
        "available": "المتاح",
        "ofAllocated": "من مخصص قدره {{allocated}}",
        "threshold": "تنبيه عند {{percent}}",
        "health": {
          "within": "ضمن المخصص",
          "warning": "يقترب من حده",
          "exceeded": "تجاوز المخصص",
          "frozen": "مجمّدة"
        }
      }
    }
  }
}
